import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { IonButton } from '@ionic/angular';

@Component({
  selector: 'bepatient-onboarding-validation-popup',
  templateUrl: './onboarding-validation-popup.component.html',
  styleUrls: ['./onboarding-validation-popup.component.scss'],
  standalone: false
})
export class OnboardingValidationPopupComponent implements AfterViewInit {
  @Input() title: string;
  @Input() content: string;
  @Input() color: string;
  @Input() buttonLabel: string;
  @Output() change = new EventEmitter<boolean>();
  @ViewChild(IonButton, { read: ElementRef, static: true })
  buttonElement: ElementRef;

  ngAfterViewInit(): void {
    const style = this.buttonElement.nativeElement.style;
    style.setProperty('--background', this.color);
    style.setProperty('--background-activated', this.color);
    style.setProperty('--background-focused', this.color);
  }
}
